import React from 'react';
import { Result, Spin } from 'antd';
import { usePermissions } from '../../contexts/PermissionContext';

interface RequireResourceProps {
  resource: string;
  children: React.ReactNode;
}

const RequireResource: React.FC<RequireResourceProps> = ({ resource, children }) => {
  const { hasPermission, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!hasPermission(resource)) {
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="No tienes permisos para acceder a este apartado."
      />
    );
  }

  return <>{children}</>;
};

export default RequireResource;
